import { Record } from "immutable";

const RiskType = Record({ id: null });

export default Object.freeze({
    PERSON: new RiskType({ id: "PERSON" }),
    PROPERTY: new RiskType({ id: "PROPERTY" }),
    VEHICLE: new RiskType({ id: "VEHICLE" }),
});
